import * as yup from 'yup'

import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Formik } from 'formik'
import { MoovyForm } from '../../components'

export type OnSubmitCallback = (values: FormValues) => void

export type FormChangeSystemStatusProps = {
  action: 'ENABLE' | 'DISABLE'
  onSubmit: OnSubmitCallback
  formReference: string
  formTitleKey: string
}

export interface FormValues {
  action: 'ENABLE' | 'DISABLE'
  comment: string
}

const FormChangeSystemStatus = (props: FormChangeSystemStatusProps) => {
  const intl = useIntl()
  const [formikValidateOnChange, setFormikValidateOnChange] = useState(false)

  const defaultValues = {
    comment: '',
  }

  const validationSchema = () => {
    return yup.object().shape({
      comment: yup
        .string()
        .trim()
        .required(intl.formatMessage({ id: 'common.form.errors.empty' })),
    })
  }

  const onSubmitFormValues = (values: Omit<FormValues, 'action'>) => {
    const { comment } = values
    props.onSubmit({
      comment: comment.trim(),
      action: props.action,
    })
  }

  return (
    <>
      <Formik
        validate={() => setFormikValidateOnChange(true)}
        validationSchema={validationSchema()}
        enableReinitialize={true}
        initialValues={defaultValues}
        validateOnChange={formikValidateOnChange}
        onSubmit={(values) => {
          onSubmitFormValues(values)
        }}
      >
        {({ values, errors, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit} id={props.formReference}>
            <MoovyForm.FormContainer>
              <MoovyForm.FormTitle
                title={<FormattedMessage id={props.formTitleKey} />}
              />
              <MoovyForm.FormBoxRow>
                <MoovyForm.FormTextField
                  name="comment"
                  data-testid="comment"
                  value={values.comment}
                  label={intl.formatMessage({
                    id: 'common.system.changeStatusForm.label.reason',
                  })}
                  placeholder={intl.formatMessage({
                    id: 'common.system.changeStatusForm.label.reason',
                  })}
                  onChange={handleChange}
                  error={!!errors.comment}
                  errorText={errors.comment}
                />
              </MoovyForm.FormBoxRow>
            </MoovyForm.FormContainer>
          </form>
        )}
      </Formik>
    </>
  )
}

export default FormChangeSystemStatus
